var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-responsive',_vm._b({attrs:{"aspect-ratio":_vm.aspectRatio}},'v-responsive',_vm.$attrs,false),[_c('iframe',{attrs:{"width":"100%","height":"100%","src":_vm.src,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }